<section class="section-div">
  <div class="header-div">
    <h4>
      <ion-icon name="newspaper-outline"></ion-icon> Result & Outcome -
      {{ incubaterName }}
    </h4>
  </div>
  <div class="content-details">
    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Number of Graduated Startups annually in the last three
                    years of operations
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.numberOfGraduatedStatus)"
                    [style.background]="
                      pickColor(getValue.numberOfGraduatedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.numberOfGraduatedStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Number of Graduated Startups annually in the last three
                    years of operations
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.numberOfGraduatedIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.numberOfGraduatedIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{ getValue.numberOfGraduatedNoOfStartup }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.numberOfGraduatedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.numberOfGraduatedStatus == 3 ||
                            getValue.numberOfGraduatedStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.numberOfGraduatedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.numberOfGraduatedStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('numberOfGraduatedStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('numberOfGraduatedStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.numberOfGraduatedStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('numberOfGraduatedStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Capacity Utilization such as Office Space, Machinery
                    established and other infrastructure
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.capacityUtilizationStatus)
                    "
                    [style.background]="
                      pickColor(getValue.capacityUtilizationStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.capacityUtilizationStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Capacity Utilization such as Office Space, Machinery
                    established and other infrastructure
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.capacityUtilizationIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.capacityUtilizationIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.capacityUtilizationUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.capacityUtilizationUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Percentage of Capacity Utilization :
                            <span
                              *ngIf="
                                getValue.capacityUtilizationPercentage == 25
                              "
                              ><b>0 - 24%</b>
                            </span>
                            <span
                              *ngIf="
                                getValue.capacityUtilizationPercentage == 50
                              "
                              ><b>25 - 50%</b>
                            </span>
                            <span
                              *ngIf="
                                getValue.capacityUtilizationPercentage == 75
                              "
                              ><b>51 - 75%</b>
                            </span>
                            <span
                              *ngIf="
                                getValue.capacityUtilizationPercentage == 100
                              "
                              ><b>76 - 100%</b>
                            </span>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.capacityUtilizationDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.capacityUtilizationStatus == 3 ||
                            getValue.capacityUtilizationStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.capacityUtilizationReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.capacityUtilizationStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('capacityUtilizationStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('capacityUtilizationStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.capacityUtilizationStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('capacityUtilizationStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Impact achieved against targeted impact through Incubated
                    startups / incubator
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.impactAchievedStatus)"
                    [style.background]="
                      pickColor(getValue.impactAchievedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.impactAchievedStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Impact achieved against targeted impact through Incubated
                    startups / incubator
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.impactAchievedPresent == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.impactAchievedPresent }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.impactAchievedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.impactAchievedStatus == 3 ||
                            getValue.impactAchievedStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.impactAchievedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.impactAchievedStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('impactAchievedStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('impactAchievedStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.impactAchievedStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('impactAchievedStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Technology Commercialized / Transferred for the technology
                    developed through Host Institute in the last one year
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.technologyCommercializedStatus)
                    "
                    [style.background]="
                      pickColor(getValue.technologyCommercializedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.technologyCommercializedStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Technology Commercialized / Transferred for the technology
                    developed through Host Institute in the last one year
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.technologyCommercializedPresent == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.technologyCommercializedPresent
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{
                              getValue.technologyCommercializedNoOfTech
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.technologyCommercializedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.technologyCommercializedStatus == 3 ||
                            getValue.technologyCommercializedStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.technologyCommercializedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.technologyCommercializedStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('technologyCommercializedStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('technologyCommercializedStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.technologyCommercializedStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('technologyCommercializedStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
